import React from 'react';

const Terms = () => {
  return (
    <div className="max-w-3xl mx-auto p-8 pt-20 min-h-screen">
      <h1 className="text-3xl font-black uppercase tracking-tight mb-6">Terms of Service</h1>
      <div className="space-y-4 text-muted-foreground">
        <p><strong>Last updated:</strong> [Today's Date]</p>
        <p>Welcome to Offer Me He Lelo. By accessing or using our website, you agree to be bound by these Terms of Service.</p>
        <p><strong>Use of Service:</strong> You agree to use our platform strictly for lawful purposes and in accordance with these terms.</p>
        <p><strong>Account:</strong> You are responsible for maintaining the confidentiality of your account credentials.</p>
        <p><strong>Payments:</strong> All payments processed through our platform are handled securely via our payment gateway partners. You agree to provide accurate billing information.</p>
        <p><strong>Service Modifications:</strong> We reserve the right to modify or discontinue the service at any time without prior notice.</p>
        <p><strong>Governing Law:</strong> These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in [Mumbai/Your City].</p>
      </div>
    </div>
  );
};
export default Terms;